import { render, staticRenderFns } from "./WorkflowTestTaskEdit.vue?vue&type=template&id=0574db6a"
import script from "./WorkflowTestTaskEdit.vue?vue&type=script&lang=js"
export * from "./WorkflowTestTaskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports